import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Import contexts
import { AuthProvider } from './contexts/AuthContext';
import { MSPAuthProvider } from './contexts/MSPAuthContext';

// Import components
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import ForgotPasswordForm from './components/auth/ForgotPasswordForm';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import Dashboard from './components/dashboard/Dashboard';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import Documentation from './components/Documentation';
import ImpersonationBanner from './components/ImpersonationBanner';
import { MSPImpersonationBar } from './components/msp/MSPImpersonationBar';
import { MSPProtectedRoute } from './components/msp/MSPProtectedRoute';

// Import pages
import HomePage from './pages/HomePage';
import { MSPLoginPage } from './pages/MSPLoginPage';
import { MSPDashboardPage } from './pages/MSPDashboardPage';

function App() {
  // Initialize dark mode based on system preference
  useEffect(() => {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.classList.add('dark');
    }
  }, []);

  return (
    <AuthProvider>
      <MSPAuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            <ImpersonationBanner />
            <MSPImpersonationBar />
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/register" element={<RegisterForm />} />
              <Route path="/forgot-password" element={<ForgotPasswordForm />} />
              <Route path="/reset-password/:token" element={<ResetPasswordForm />} />
              <Route path="/documentation" element={<Documentation />} />
              
              {/* MSP routes */}
              <Route path="/msp/login" element={<MSPLoginPage />} />
              <Route 
                path="/msp/dashboard" 
                element={
                  <MSPProtectedRoute>
                    <MSPDashboardPage />
                  </MSPProtectedRoute>
                } 
              />
              
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<AdminDashboard />} />
              
              {/* Protected routes */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              
              {/* Redirect unknown routes to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </MSPAuthProvider>
    </AuthProvider>
  );
}

export default App;